import { useEffect, useRef, useState } from "react"
import { useTranslation } from "react-i18next"
import CloseIcon from "@mui/icons-material/Close"
import {
  Avatar,
  Backdrop,
  Box,
  Button,
  DialogTitle,
  IconButton,
  Alert,
  Grid,
} from "@mui/material"
import { treatView } from "@/gluelayer"
import { useAppSelector, useAppDispatch } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import { UText } from "@/components/index"
import {
  setOpenOrderSplit,
  setOpenStlPrint,
  setStageShowType,
  setIsCreateNewRefinement
} from "@/UDTreat/udTreatSlice"
import { OrderStlPrint } from "../OrderStlPrint/OrderStlPrint"
import Order from "@/UDTreat/Order/Order"
import { orderView } from "@/gluelayer"


export const OrderSplit = () => {
  const { openOrderSplit, openStlPrint } = useAppSelector(
    (state: RootState) => state.udTreatService,
  )
  const dispatch = useAppDispatch()
  const isSplitWasm = useRef(false)
  const getOrderContainer = () => {
    if (openStlPrint) {
      return <OrderStlPrint />
    }
    return <Order />
  }

  const closeOrderSplit = () => {
    dispatch(setOpenOrderSplit(false))
    if (openStlPrint) {
      treatView.Open(false)
      dispatch(setStageShowType("normal"))
      dispatch(setOpenStlPrint(false))
    }
    /**
     * 关闭页面时，将WASM部分还原
     */
    orderView.splitPageForOrder(false)
  }

  /**
   * 打开页面时，将WASM部分分割成左右两部分
   */
  useEffect(() => {
    if (openOrderSplit && !isSplitWasm.current) {  
      orderView.splitPageForOrder(true)
      isSplitWasm.current = true
    }
  },[openOrderSplit])


  return (
    <Box
      id="orderSplit"
      sx={{
        backgroundColor: "#f5f5f5",
        width: "60%",
        height: "calc(100% - 40px)",
        position: "absolute",
        top: "40px",
        right: "0",
        zIndex: "10",
        overflowY: "auto",
      }}
    >
      <IconButton
        aria-label="close"
        onClick={() => {
          closeOrderSplit()
        }}
        sx={{
          position: "absolute",
          right: 12,
          top: 10,
          color: (theme) => theme.palette.grey[500],
        }}
      >
        <CloseIcon />
      </IconButton>
      <Box id={"splitContainer"} sx={{ width: "100%", padding: "60px 80px" }}>
        {getOrderContainer()}
        {/* <Box sx={{ width: "100%", textAlign: "center", marginBottom: "38px" }}>
          <UText variant={"h4"}>{`Order STL Print`}</UText>
        </Box> */}
      </Box>
    </Box>
  )
}
